/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import React from 'react'

/* global WorldWind */

export default class TampereCityCenterParking extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "City Center Parking Map",
            service: "https://geodata.tampere.fi/geoserver/wms?service=WMS",
            version: "1.3.0",
            layerNames: "liikennealueet:pysakointi_pysakointipaikat_polygon_gk24",
        };

        super(cfg);

        this.urlBuilder.transparent = true;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                " Open Data Tampere",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>Aineistosta löytyvät Tampereen alueen yleisillä katu- ja pysäköintialueilla olevat maksulliset ja
                maksuttomat pysäköintipaikat. Lisäksi aineistosta löytyy mm. keskusta-alueella olevat asukas- ja
                yrityspysäköintipaikat ja eri käyttäjäryhmille tarkoitetut paikat. Pysäköintilaitosten (yleiset)
                tiedoissa on vain paikkamäärä. Aineistoa päivitetään pysäköintiä koskevien päätöksien toteutumisen
                jälkeen. Vastuutaho liikennejärjestelmän suunnittelu. Aineisto tallennetaan ETRS-GK24 (EPSG:3878)
                tasokoordinaattijärjestelmässä.
            </p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <img
                    src={"https://geodata.tampere.fi/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=liikennealueet%3Apysakointi_pysakointipaikat_polygon_gk24"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                Legend
            </p>
        </div>);
    }
}
